const mutations = {
  getContactUs: (state, contact_us) => {
    state.contact_us = contact_us;
  },
  getContactUsId: (state, contact_us_id) => {
    state.contact_us_id = contact_us_id;
  },
  postContactUs: (state, new_contact_us) => {
    state.contact_us.push(new_contact_us);
  },
  updateContactUs: (state, new_status) => {
    state.contact_us = state.contact_us.map((contact_us) => {
      if (contact_us.id === new_status.contact_us_id) {
        return Object.assign({}, contact_us, new_status.status);
      }
      return contact_us;
    });
  },
  putContactUs: (state, payload) => {
    state.contact_us = state.contact_us.map((contact_us) => {
      if (contact_us.contact_us_id === payload.id) {
        return Object.assign({}, contact_us, payload.formData);
      }
      return contact_us;
    });
  },
  delContactUs(state, id) {
    const index = state.contact_us.findIndex(contact_us => contact_us.contact_us_id == id);
    state.contact_us.splice(index, 1);
  },
  getEnableDisableFeature: (state, enable_disable_feature) => {
    state.enable_disable_feature = enable_disable_feature;
  },
  getEnableDisableFeatureId: (state, enable_disable_feature_id) => {
    state.enable_disable_feature_id = enable_disable_feature_id;
  },
  postEnableDisableFeature: (state, new_enable_disable_feature) => {
    state.enable_disable_feature.push(new_enable_disable_feature);
  },
  updateEnableDisableFeature: (state, new_status) => {
    state.enable_disable_feature = state.enable_disable_feature.map((enable_disable_feature) => {
      if (enable_disable_feature.id === new_status.enable_disable_feature_id) {
        return Object.assign({}, enable_disable_feature, new_status.status);
      }
      return enable_disable_feature;
    });
  },
  putEnableDisableFeature: (state, payload) => {
    state.enable_disable_feature = state.enable_disable_feature.map((enable_disable_feature) => {
      if (enable_disable_feature.enable_disable_feature_id === payload.id) {
        return Object.assign({}, enable_disable_feature, payload.formData);
      }
      return enable_disable_feature;
    });
  },
  delEnableDisableFeature(state, id) {
    const index = state.enable_disable_feature.findIndex(enable_disable_feature => enable_disable_feature.enable_disable_feature_id == id);
    state.enable_disable_feature.splice(index, 1);
  },
  getNewUser: (state, new_user) => {
    state.new_user = new_user;
  },
  getNewUserId: (state, new_user_id) => {
    state.new_user_id = new_user_id;
  },
  postNewUser: (state, new_new_user) => {
    state.new_user.push(new_new_user);
  },
  updateNewUser: (state, new_status) => {
    state.new_user = state.new_user.map((new_user) => {
      if (new_user.id === new_status.new_user_id) {
        return Object.assign({}, new_user, new_status.status);
      }
      return new_user;
    });
  },
  putNewUser: (state, payload) => {
    state.new_user = state.new_user.map((new_user) => {
      if (new_user.new_user_id === payload.id) {
        return Object.assign({}, new_user, payload.formData);
      }
      return new_user;
    });
  },
  delNewUser(state, id) {
    const index = state.new_user.findIndex(new_user => new_user.new_user_id == id);
    state.new_user.splice(index, 1);
  },
};

export default mutations;
